/**
 * Thickness Upcharges by Product Code
 * Format: THICKNESS_UPCHARGES[productCode][thicknessCode][sizeCode] = dollarAmount
 * Example: THICKNESS_UPCHARGES.BL31000.FCO_38["06"] → 15.95
 */

export const THICKNESS_UPCHARGES = {
  BL31000: {
    FCO_14: {
      "02": 0,
      "03": 0,
      "04": 0,
      "05": 0,
      "06": 0,
      "07": 0,
      "08": 0,
      "09": 0,
      10: 0,
      11: 0,
      12: 0,
      13: 0,
      14: 0,
      15: 0,
      16: 0,
      17: 0,
      18: 0,
      19: 0,
      20: 0,
      21: 0,
      22: 0,
      23: 0,
      24: 0,
    },
    FCO_38: {
      "02": 13.2,
      "03": 13.09,
      "04": 17.49,
      "05": 20.35,
      "06": 15.95,
      "07": 22.0,
      "08": 24.64,
      "09": 29.26,
      10: 30.91,
      11: 30.69,
      12: 36.52,
      13: 38.06,
      14: 42.46,
      15: 49.61,
      16: 61.49,
      17: 64.24,
      18: 77.55,
      19: 80.19,
      20: 78.98,
      21: 80.41,
      22: 83.16,
      23: 86.35,
      24: 52.58,
    },
    FCO_12: {
      "02": 24.97,
      "03": 27.72,
      "04": 27.83,
      "05": 30.58,
      "06": 30.58,
      "07": 29.26,
      "08": 30.91,
      "09": 38.06,
      10: 38.06,
      11: 46.86,
      12: 55.55,
      13: 67.32,
      14: 76.01,
      15: 84.15,
      16: 96.36,
      17: 112.64,
      18: 132.88,
      19: 140.14,
      20: 150.48,
      21: 162.14,
      22: 173.91,
      23: 182.71,
      24: 160.71,
    },
    FCO_34: {
      "02": 30.69,
      "03": 33.55,
      "04": 32.12,
      "05": 36.52,
      "06": 42.13,
      "07": 52.69,
      "08": 65.67,
      "09": 78.98,
      10: 93.61,
      11: 108.13,
      12: 131.56,
      13: 147.73,
      14: 170.94,
      15: 191.51,
      16: 222.2,
      17: 252.78,
      18: 289.3,
      19: 316.91,
      20: 340.45,
      21: 371.14,
      22: 400.29,
      23: 428.12,
      24: 428.01,
    },
    FCO_10: {
      "02": 39.49,
      "03": 39.38,
      "04": 40.92,
      "05": 48.8,
      "06": 52.47,
      "07": 62.24,
      "08": 84.81,
      "09": 109.67,
      10: 137.8,
      11: 165.22,
      12: 195.8,
      13: 228.03,
      14: 260.15,
      15: 289.3,
      16: 333.19,
      17: 372.57,
      18: 420.75,
      19: 470.36,
      20: 523.05,
      21: 578.71,
      22: 636.9,
      23: 696.96,
      24: 730.51,
    },
  },

  BL32000: {
    FCO_14: {
      "02": 0,
      "03": 0,
      "04": 0,
      "05": 0,
      "06": 0,
      "07": 0,
      "08": 0,
      "09": 0,
      10: 0,
      11: 0,
      12: 0,
      13: 0,
      14: 0,
      15: 0,
      16: 0,
      17: 0,
      18: 0,
      19: 0,
      20: 0,
      21: 0,
      22: 0,
      23: 0,
      24: 0,
    },
    FCO_38: {
      "02": 13.42,
      "03": 15.62,
      "04": 18.59,
      "05": 24.53,
      "06": 33.22,
      "07": 37.18,
      "08": 47.52,
      "09": 59.4,
      10: 73.26,
      11: 80.08,
      12: 88.88,
      13: 88.88,
      14: 110.33,
      15: 122.87,
      16: 138.16,
      17: 154.66,
      18: 170.28,
      19: 190.3,
      20: 211.42,
      21: 227.59,
      22: 241.78,
      23: 256.52,
      24: 267.85,
    },
    FCO_12: {
      "02": 17.05,
      "03": 17.05,
      "04": 30.91,
      "05": 49.83,
      "06": 60.83,
      "07": 66.66,
      "08": 85.8,
      "09": 108.9,
      10: 138.49,
      11: 169.07,
      12: 203.17,
      13: 238.38,
      14: 274.12,
      15: 312.62,
      16: 358.6,
      17: 408.54,
      18: 459.14,
      19: 511.17,
      20: 599.94,
      21: 661.43,
      22: 718.85,
      23: 778.25,
      24: 840.62,
    },
  },

  BL33000: {
    FCO_14: {
      "02": 0,
      "03": 0,
      "04": 0,
      "05": 0,
      "06": 0,
      "07": 0,
      "08": 0,
      "09": 0,
      10: 0,
      11: 0,
      12: 0,
      13: 0,
      14: 0,
      15: 0,
      16: 0,
      17: 0,
      18: 0,
      19: 0,
      20: 0,
      21: 0,
      22: 0,
      23: 0,
      24: 0,
    },
    FCO_38: {
      "02": 13.42,
      "03": 15.62,
      "04": 18.59,
      "05": 24.53,
      "06": 33.22,
      "07": 37.18,
      "08": 47.52,
      "09": 59.4,
      10: 73.26,
      11: 80.08,
      12: 88.88,
      13: 88.88,
      14: 110.33,
      15: 122.87,
      16: 138.16,
      17: 154.66,
      18: 170.28,
      19: 190.3,
      20: 211.42,
      21: 227.59,
      22: 241.78,
      23: 256.52,
      24: 267.85,
    },
    FCO_12: {
      "02": 17.05,
      "03": 17.05,
      "04": 30.91,
      "05": 49.83,
      "06": 60.83,
      "07": 66.66,
      "08": 85.8,
      "09": 108.9,
      10: 138.49,
      11: 169.07,
      12: 203.17,
      13: 238.38,
      14: 274.12,
      15: 312.62,
      16: 358.6,
      17: 408.54,
      18: 459.14,
      19: 511.17,
      20: 599.94,
      21: 661.43,
      22: 718.85,
      23: 778.25,
      24: 840.62,
    },
  },

  BL40100: {
    FCO_18: {
      "02": 0,
      "03": 0,
      "04": 0,
      "05": 0,
      "06": 0,
      "07": 0,
      "08": 0,
      "09": 0,
      10: 0,
      11: 0,
      12: 0,
      13: 0,
      14: 0,
      15: 0,
      16: 0,
      17: 0,
      18: 0,
      19: 0,
      20: 0,
      21: 0,
      22: 0,
      23: 0,
      24: 0,
    },
    FCO_14: {
      "02": 0.33,
      "03": 1.96,
      "04": 2.98,
      "05": 2.68,
      "06": 3.2,
      "07": 4.43,
      "08": 5.76,
      "09": 6.6,
      10: 6.9,
      11: 7.79,
      12: 8.85,
      13: 9.37,
      14: 11.53,
      15: 12.77,
      16: 14.52,
      17: 16.48,
      18: 17.72,
      19: 18.95,
      20: 18.54,
      21: 19.57,
      22: 24.92,
      23: 26.37,
      24: 27.6,
    },
    FCO_38: {
      "02": 5.05,
      "03": 7.52,
      "04": 8.34,
      "05": 8.34,
      "06": 10.82,
      "07": 10.71,
      "08": 13.28,
      "09": 18.44,
      10: 14.83,
      11: 15.76,
      12: 17.61,
      13: 20.3,
      14: 23.01,
      15: 25.85,
      16: 19.15,
      17: 30.6,
      18: 34.36,
      19: 36.77,
      20: 40.58,
      21: 44.6,
      22: 44.97,
      23: 52.12,
      24: 57.37,
    },
    FCO_12: {
      "02": 8.14,
      "03": 9.48,
      "04": 11.74,
      "05": 11.74,
      "06": 14.42,
      "07": 15.56,
      "08": 18.44,
      "09": 20.6,
      10: 21.63,
      11: 24.0,
      12: 24.0,
      13: 33.06,
      14: 36.25,
      15: 36.9,
      16: 40.0,
      17: 43.99,
      18: 47.99,
      19: 54.9,
      20: 58.0,
      21: 63.04,
      22: 68.06,
      23: 75.06,
      24: 81.06,
    },
  },

  BL40200: {
    FCO_18: {
      "02": 0,
      "03": 0,
      "04": 0,
      "05": 0,
      "06": 0,
      "07": 0,
      "08": 0,
      "09": 0,
      10: 0,
      11: 0,
      12: 0,
      13: 0,
      14: 0,
      15: 0,
      16: 0,
      17: 0,
      18: 0,
      19: 0,
      20: 0,
      21: 0,
      22: 0,
      23: 0,
      24: 0,
    },
    FCO_14: {
      "02": 0,
      "03": 1.5,
      "04": 2.6,
      "05": 2.2,
      "06": 3,
      "07": 4.1,
      "08": 4.7,
      "09": 5.7,
      10: 6.1,
      11: 6.8,
      12: 7.4,
      13: 8,
      14: 10.2,
      15: 11.2,
      16: 12.2,
      17: 14.3,
      18: 15.1,
      19: 16.5,
      20: 16.3,
      21: 16.7,
      22: 21.4,
      23: 22.6,
      24: 23.9,
    },
    FCO_38: {
      "02": 0,
      "03": 7,
      "04": 7.5,
      "05": 7.1,
      "06": 9.1,
      "07": 10.1,
      "08": 11.4,
      "09": 12.9,
      10: 13.7,
      11: 15,
      12: 17.4,
      13: 20,
      14: 22.6,
      15: 25.1,
      16: 27.4,
      17: 30.6,
      18: 33.7,
      19: 37.1,
      20: 40.1,
      21: 43.6,
      22: 47.7,
      23: 51.4,
      24: 56.1,
    },
    FCO_12: {
      "02": 0,
      "03": 8.4,
      "04": 9.1,
      "05": 10,
      "06": 12.2,
      "07": 13.7,
      "08": 16.3,
      "09": 17.9,
      10: 19.8,
      11: 21.5,
      12: 25.1,
      13: 28.6,
      14: 32,
      15: 32.7,
      16: 35.8,
      17: 39.5,
      18: 43.4,
      19: 48,
      20: 52.1,
      21: 56.6,
      22: 61.8,
      23: 66.7,
      24: 72.6,
    },
  },

  PFL100: {
    one_half_inch: {
      "04": 0,
      "05": 0,
      "06": 0,
      "07": 0,
      "08": 0,
      "09": 0,
      10: 0,
      11: 0,
      12: 0,
      13: 0,
      14: 0,
      15: 0,
      16: 0,
      17: 0,
      18: 0,
      19: 0,
      20: 0,
      21: 0,
      22: 0,
      23: 0,
      24: 0,
    },
    three_quarter_inch: {
      "04": 2.2,
      "05": 3.4,
      "06": 3.8,
      "07": 4.8,
      "08": 6.0,
      "09": 6.5,
      10: 7.3,
      11: 8.5,
      12: 9.6,
      13: 10.6,
      14: 11.4,
      15: 9.0,
      16: 10.4,
      17: 10.9,
      18: 12.0,
      19: 13.3,
      20: 14.7,
      21: 16.1,
      22: 17.8,
      23: 19.1,
      24: 20.3,
    },
    one_inch: {
      "04": 5.2,
      "05": 6.7,
      "06": 8.0,
      "07": 10.1,
      "08": 12.4,
      "09": 13.7,
      10: 15.9,
      11: 18.1,
      12: 21.0,
      13: 23.7,
      14: 26.3,
      15: 25.4,
      16: 28.4,
      17: 30.9,
      18: 33.9,
      19: 37.9,
      20: 41.5,
      21: 45.3,
      22: 49.9,
      23: 53.8,
      24: 58.0,
    },
    one_and_half_inch: {
      "04": 100.0,
      "05": 100.0,
      "06": 11.4,
      "07": 13.7,
      "08": 17.2,
      "09": 19.1,
      10: 22.5,
      11: 25.6,
      12: 29.6,
      13: 33.7,
      14: 37.5,
      15: 37.9,
      16: 42.2,
      17: 46.2,
      18: 50.4,
      19: 56.4,
      20: 61.9,
      21: 67.6,
      22: 74.2,
      23: 80.2,
      24: 87.0,
    },
    two_inch: {
      "04": 100.0,
      "05": 100.0,
      "06": 14.6,
      "07": 17.7,
      "08": 21.8,
      "09": 25.1,
      10: 29.2,
      11: 33.0,
      12: 38.6,
      13: 43.7,
      14: 48.9,
      15: 50.2,
      16: 56.0,
      17: 61.4,
      18: 67.6,
      19: 75.1,
      20: 82.4,
      21: 90.0,
      22: 99.0,
      23: 107.0,
      24: 115.9,
    },
  },

  BL70100: {
    FCO_14: {
      "03": 0,
      "04": 0,
      "05": 0,
      "06": 0,
      "07": 0,
      "08": 0,
      "09": 0,
      10: 0,
      11: 0,
      12: 0,
      13: 0,
      14: 0,
      15: 0,
      16: 0,
      17: 0,
      18: 0,
      19: 0,
      20: 0,
      21: 0,
      22: 0,
      23: 0,
      24: 0,
    },
    FCO_38: {
      "03": 4.7,
      "04": 4.6,
      "05": 5.2,
      "06": 6.5,
      "07": 5.3,
      "08": 6.4,
      "09": 6.1,
      10: 6.7,
      11: 6.7,
      12: 7.5,
      13: 9.4,
      14: 9.9,
      15: 11.1,
      16: 12.5,
      17: 12.1,
      18: 14.2,
      19: 15.2,
      20: 18.8,
      21: 21.3,
      22: 18.8,
      23: 22.0,
      24: 25.4,
    },
    FCO_12: {
      "03": 7.7,
      "04": 6.4,
      "05": 7.0,
      "06": 8.2,
      "07": 8.0,
      "08": 9.1,
      "09": 9.9,
      10: 10.3,
      11: 11.2,
      12: 12.9,
      13: 16.9,
      14: 17.4,
      15: 16.2,
      16: 18.2,
      17: 18.9,
      18: 20.8,
      19: 25.1,
      20: 28.3,
      21: 30.4,
      22: 30.0,
      23: 34.0,
      24: 37.2,
    },
    FCO_34: {
      "03": 12.0,
      "04": 13.6,
      "05": 14.3,
      "06": 16.9,
      "07": 18.1,
      "08": 21.5,
      "09": 23.5,
      10: 25.2,
      11: 29.8,
      12: 34.0,
      13: 39.5,
      14: 42.3,
      15: 43.5,
      16: 46.9,
      17: 51.3,
      18: 56.8,
      19: 62.5,
      20: 70.7,
      21: 77.7,
      22: 79.9,
      23: 87.8,
      24: 95.7,
    },
    FCO_10: {
      "03": 17.4,
      "04": 22.9,
      "05": 22.8,
      "06": 27.3,
      "07": 31.1,
      "08": 37.0,
      "09": 40.0,
      10: 45.4,
      11: 45.9,
      12: 57.7,
      13: 66.7,
      14: 73.0,
      15: 75.3,
      16: 82.3,
      17: 89.0,
      18: 98.3,
      19: 108.6,
      20: 120.4,
      21: 131.0,
      22: 141.4,
      23: 153.8,
      24: 166.6,
    },
    FCO_112: {
      "03": 37.5,
      "04": 44.4,
      "05": 47.6,
      "06": 57.0,
      "07": 63.3,
      "08": 75.79,
      "09": 86.2,
      10: 97.2,
      11: 109.0,
      12: 125.1,
      13: 142.3,
      14: 158.1,
      15: 165.2,
      16: 180.3,
      17: 197.6,
      18: 217.5,
      19: 237.4,
      20: 262.0,
      21: 285.8,
      22: 307.9,
      23: 335.8,
      24: 362.7,
    },
  },
};

/**
 * Get thickness upcharge in dollars
 * @param {string} productCode - e.g. "BL31000"
 * @param {string} thickness - e.g. "FCO_38"
 * @param {string} size - e.g. "06"
 * @returns {number} Dollar amount to add
 */
export const getThicknessUpcharge = (productCode, thickness, size) => {
  const upcharge = THICKNESS_UPCHARGES[productCode]?.[thickness]?.[size];
  return upcharge ?? 0;
};
